/**
 * Componente de sugestões de conflito (409)
 */

import type { PublicProvider } from "../types";

interface ConflictSuggestionsProps {
  suggested: Array<{ time: string; providerId?: string }>;
  providers: PublicProvider[];
  showSuggestions: boolean;
  onSelectSuggestion: (time: string, providerId?: string) => void;
  onHideSuggestions: () => void;
}

export function ConflictSuggestions({
  suggested,
  providers,
  showSuggestions,
  onSelectSuggestion,
  onHideSuggestions,
}: ConflictSuggestionsProps) {
  if (!showSuggestions || suggested.length === 0) return null;

  return (
    <div className="mb-4 p-3 rounded-lg border-2 border-yellow-300 bg-yellow-50 text-yellow-900">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="font-medium">
          Esse horário acabou de ficar indisponível. Que tal um destes?
        </div>
        <button
          type="button"
          className="text-sm text-yellow-800 underline"
          onClick={onHideSuggestions}
        >
          Ocultar sugestões
        </button>
      </div>

      <div className="mt-2 flex flex-wrap gap-2">
        {suggested.map((sug, idx) => (
          <button
            key={`${sug.time}-${sug.providerId || "any"}-${idx}`}
            type="button"
            onClick={() => onSelectSuggestion(sug.time, sug.providerId)}
            className="px-3 py-1.5 rounded-lg border-2 border-yellow-300 bg-white hover:bg-yellow-100 text-yellow-900 text-sm"
          >
            {sug.time}
            {(() => {
              if (!sug.providerId) return null;
              const p = providers.find((pp) => pp.id === sug.providerId);
              return p ? <span className="opacity-70"> · {p.name}</span> : null;
            })()}
          </button>
        ))}
      </div>
    </div>
  );
}
